import { PapiDeviation } from '@wix/da-papi-types';
import { formatDollars } from '../../../../utils/formatting';

const premiumContentAdapter = (props: any) => {
  const deviation: PapiDeviation = props!.deviation;

  const price = deviation.pcp?.downloadPrice ?? '???';

  const dollarsCost =
    deviation.pcp?.downloadDollarPrice !== undefined
      ? formatDollars(deviation.pcp.downloadDollarPrice)
      : '???';

  return {
    ...props,
    price,
    dollarsCost,
    priceLabel: 'shop.thumb.points',
  };
};

export default premiumContentAdapter;
